import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CommonSelect from "../../../core/common/commonSelect";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import { company_short_name } from "../../../environment";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { Switch } from "antd";

const Packages = () => {
  const handleStatusChange = async (checked: boolean, record: any) => {
    const newData = filteredData.map((item) =>
      item.Plan_Name === record.Plan_Name
        ? { ...item, Status: checked ? "Active" : "Inactive" }
        : item
    );
    setFilteredData(newData); // Update state
    // Post data to API
    try {
      const signature = localStorage.getItem("signature");

      const dataToSend = {
        signature: signature,
        status: checked ? 1 : 0,
        id: record.key,
      };

      try {
        setIsLoading(true);
        const response = await api.post(
          "userService/updatePackage",
          dataToSend
        );
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        setIsLoading(false); // hide loader after response
      }
    } catch (error) {
      console.error("Error adding plan:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };
  interface SelectedData {
    menu: string;
    sub_menus: string[];
  }
  const [selectedData, setSelectedData] = useState<SelectedData[]>([]);

  const [isLoading, setIsLoading] = useState(false); // state to track loading
  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [planFilter, setPlanFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };
  //const data = package_list;
  const columns = [
    {
      title: "Plan Name",
      dataIndex: "Plan_Name",
      render: (text: String, record: any) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => {
        const lengthA = a.Plan_Name ? a.Plan_Name.toString().length : 0;
        const lengthB = b.Plan_Name ? b.Plan_Name.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "Plan Type",
      dataIndex: "Plan_Type",
      sorter: (a: any, b: any) => {
        const lengthA = a.Plan_Type ? a.Plan_Type.toString().length : 0;
        const lengthB = b.Plan_Type ? b.Plan_Type.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "Total Subscribers",
      dataIndex: "Total_Subscribers",
      sorter: (a: any, b: any) =>
        parseFloat(a.Total_Subscribers) - parseFloat(b.Total_Subscribers),
    },
    {
      title: "Price",
      dataIndex: "Price",
      sorter: (a: any, b: any) => parseFloat(a.Price) - parseFloat(b.Price),
    },
    {
      title: "Tax",
      dataIndex: "Tax",
      sorter: (a: any, b: any) => parseFloat(a.Tax) - parseFloat(b.Tax),
    },
    {
      title: "Created Date",
      dataIndex: "Created_Date",
      sorter: (a: any, b: any) =>
        new Date(a.Created_Date).getTime() - new Date(b.Created_Date).getTime(),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "Active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: any, record: any) => (
        <div className="d-flex align-items-center">
          {/* Switch Button */}
          <Switch
            checked={record.Status === "Active"}
            onChange={(checked) => handleStatusChange(checked, record)}
          />

          {/* Delete Icon */}
        </div>
      ),
    },
  ];

  const planName = [
    { value: "Advanced", label: "Advanced" },
    { value: "Basic", label: "Basic" },
    { value: "Enterprise", label: "Enterprise" },
  ];
  const planType = [
    { value: "Monthly", label: "Monthly" },
    { value: "Yearly", label: "Yearly" },
  ];
  const currency = [
    { value: "INR", label: "INR" },
    { value: "USD", label: "USD" },
  ];
  const planPosition = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
  ];

  const plancurrency = [
    { value: "Fixed", label: "Fixed" },
    { value: "Percentage", label: "Percentage" },
  ];
  const discountType = [
    { value: "Fixed", label: "Fixed" },
    { value: "Percentage", label: "Percentage" },
  ];
  const status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  const taxType = [
    { value: "GST", label: "GST" },
    { value: "VAT", label: "VAT" },
    { value: "Sales Tax", label: "Sales Tax" },
    { value: "Service Tax", label: "Service Tax" },
  ];

  const [data, setData] = useState<any[]>([]);
  const [dataTax, setDataTax] = useState<any[]>([]);
  const [dataCurrency, setDataCurrency] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [responseDataPackage, setResponseDataPackage] = useState<
    any | undefined
  >(undefined);

  const [menuSubMenu, setmenuSubMenu] = useState<any[]>([]);

  const handleReset = () => {
    setFilteredData(data);
  };
  useEffect(() => {
    // This will run when the component mounts
    const fetchPackagesData = async () => {
      try {
        updateUI();
      } catch (err) {}
    };

    fetchPackagesData();
  }, []);

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (
            statusFilter &&
            item.Status.toLowerCase() !== statusFilter.toLowerCase()
          ) {
            return false;
          }
          if (planFilter && item.Plan_Type !== planFilter) {
            return false;
          }
          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.Created_Date);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.Plan_Name.localeCompare(b.Plan_Name);
            case "Descending":
              return b.Plan_Name.localeCompare(a.Plan_Name);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.Created_Date).getTime() -
                new Date(a.Created_Date).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.Created_Date) >= oneMonthAgo &&
                new Date(a.Created_Date) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.Created_Date).getTime() -
                new Date(a.Created_Date).getTime();

              // If the created date is within the last 7 days, continue sorting by Created_Date
              if (
                new Date(b.Created_Date) >= sevenDaysAgo &&
                new Date(a.Created_Date) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.Created_Date).getTime() -
                new Date(a.Created_Date).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [statusFilter, planFilter, sortBy, selectedStartDate, selectedEndDate]);

  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = [
      "Plan Name",
      "Plan Type",
      "Total Subscriber",
      "Price",
      "Tax",
      "Date",
      "Status",
    ];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.Plan_Name,
      item.Plan_Type,
      item.Total_Subscribers,
      item.Price,
      item.Tax,
      new Date(item.Created_Date).toLocaleDateString(),
      item.Status,
    ]);
    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("Packages.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "packages.xlsx");
  };

  var initialFormData = {
    planName: "",
    planType: "",
    price: "",
    tax: "",
    currency: "",
    discountType: "",
    discount: "",
    status: "",
    modules: [""],
    menuTypes: [""],
    description: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  var initialFormDataTax = {
    taxType: "",
    taxRate: "",
    status: "",
  };
  const [formDataTax, setFormDataTax] = useState(initialFormDataTax);

  const [selectAll, setSelectAll] = useState(false);
  const modules = [
    "Dashboard",
    "Applications",
    "Reports",
    "Contacts",
    "Companies",
    "Deals",
    "Leads",
    "Leads Transfer",
    "Deals Transfer",
    "Leads Form",
    "Facebook Connect",
    "Webhook Integration",
    "Leads In Queue",
    "Pipelines",
    "Analytics",
    "Activities",
    "CRM Settings",
    "Call Logs",
    "Employees",
    "Tickets",
    "Holidays",
    "Attendance",
    "Performance",
    "Training",
    "Promotion",
    "Resignation",
    "Termination",
    "Assets",
    "Reports",
    "Settings",
  ];

  const [selectAllMenu, setSelectAllMenu] = useState(false);
  const menuItems = ["MAIN MENU", "HRM", "CRM", "ADMINISTRATION"];

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleInputChangeTax = (e: any) => {
    const { name, value } = e.target;
    setFormDataTax({ ...formDataTax, [name]: value });
  };

  const handleModuleChange = (module: any) => {
    setFormData((prevData: any) => {
      const newModules = prevData.modules.includes(module)
        ? prevData.modules.filter((mod: any) => mod !== module)
        : [...prevData.modules, module];
      return { ...prevData, modules: newModules };
    });
  };

  const handleMenuChange = (module: any) => {
    setFormData((prevData: any) => {
      const newModules = prevData.menuTypes.includes(module)
        ? prevData.menuTypes.filter((mod: any) => mod !== module)
        : [...prevData.menuTypes, module];
      return { ...prevData, menuTypes: newModules };
    });
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setFormData((prevData: any) => ({
      ...prevData,
      modules: !selectAll ? modules : [],
    }));
  };

  const handleSelectAllMenu = () => {
    setSelectAllMenu(!selectAllMenu);
    setFormData((prevData: any) => ({
      ...prevData,
      menuTypes: !selectAllMenu ? menuItems : [],
    }));
  };

  const handleSubmit = async () => {
    // Validation logic here (e.g., required fields, file size)
    if (
      !formData.planName ||
      !formData.planType ||
      !formData.price ||
      !formData.tax ||
      !formData.currency ||
      !formData.discount ||
      !formData.discountType ||
      !formData.status
    ) {
      showBasicAlert("Please fill all required fields.");
      return;
    }

    // Post data to API
    try {
      const signature = localStorage.getItem("signature");

      const dataToSend = {
        signature: signature,
        name: formData.planName,
        type: formData.planType.toLowerCase() == "monthly" ? 1 : 2,
        type_char: formData.planType,
        price: parseFloat(formData.price),
        tax: parseFloat(formData.tax),
        currency: formData.currency,
        discountType: formData.discountType,
        discount: parseInt(formData.discount),
        status: formData.status.toLowerCase() == "active" ? 1 : 0,
        menuSubMenu: selectedData,
        description: formData.description,
      };

      try {
        setIsLoading(true);
        const response = await api.post(
          "userService/addNewPackage",
          dataToSend
        );
        setFormData(initialFormData);
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        await updateUI();
        setIsLoading(false); // hide loader after response
      }
    } catch (error) {
      console.error("Error adding plan:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  const handleSubmitTax = async () => {
    // Validation logic here (e.g., required fields, file size)
    if (!formDataTax.taxRate || !formDataTax.taxRate || !formDataTax.status) {
      showBasicAlert("Please fill all required fields.");
      return;
    }

    // Post data to API
    try {
      const signature = localStorage.getItem("signature");

      const dataToSend = {
        signature: signature,
        taxRate: parseFloat(formDataTax.taxRate),
        taxType: formDataTax.taxType,
        status: formDataTax.status.toLowerCase() == "active" ? 1 : 0,
      };
      try {
        setIsLoading(true);
        const response = await api.post("userService/addNewTax", dataToSend);
        setFormDataTax(initialFormDataTax);
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        await updateUI();
        setIsLoading(false); // hide loader after response
      }
    } catch (error) {
      console.error("Error adding Tax:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  const updateUI = async () => {
    const signature = localStorage.getItem("signature");

    const [response, taxDetails, getCurrency, menuSubMenu] = await Promise.all([
      api.post("userService/getPackageData", {
        signature,
      }),
      api.post("userService/getTaxDetails", {
        signature,
      }),
      api.post("userService/getCurrency", {
        signature,
      }),
      api.post("userService/getMenuSubMenu", { signature }),
    ]);

    setResponseDataPackage(response.data.data);
    setData(response.data.data.package_data);
    setFilteredData(response.data.data.package_data);
    setDataTax(taxDetails.data.data.data);
    setDataCurrency(getCurrency.data.data);
    setmenuSubMenu(menuSubMenu.data.data.data);
  };

  const handleMenuCheckbox = (menu: any) => {
    setSelectedData((prev: any) => {
      const menuExists = prev.find((item: any) => item.menu === menu.title);

      if (menuExists) {
        // Remove the menu if unchecked
        return prev.filter((item: any) => item.menu !== menu.title);
      } else {
        // Add the menu with an empty sub-menu array
        return [...prev, { menu: menu.title, sub_menus: [] }];
      }
    });
  };

  const handleSubMenuCheckbox = (menu: any, subMenu: any) => {
    setSelectedData((prev: any) =>
      prev.map((item: any) => {
        if (item.menu === menu.title) {
          const subMenuExists = item.sub_menus.includes(subMenu);

          return {
            ...item,
            sub_menus: subMenuExists
              ? item.sub_menus.filter((sub: any) => sub !== subMenu)
              : [...item.sub_menus, subMenu],
          };
        }
        return item;
      })
    );
  };

  if (
    responseDataPackage == undefined &&
    dataTax == undefined &&
    dataCurrency == undefined
  ) {
    return <Loader />;
  } else {
    return (
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Packages</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.superAdminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Superadmin</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Packages List
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                {/* <div className="me-2 mb-2">
                  <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                    <Link
                      to={all_routes.superAdminPackages}
                      className="btn btn-icon btn-sm active bg-primary text-white me-1"
                    >
                      <i className="ti ti-list-tree" />
                    </Link>
                    <Link
                      to={all_routes.superAdminPackagesGrid}
                      className="btn btn-icon btn-sm"
                    >
                      <i className="ti ti-layout-grid" />
                    </Link>
                  </div>
                </div> */}
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={handleExportPDF}
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={handleExportExcel}
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="me-2 mb-2">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#add_plans"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Package
                  </Link>
                </div>

                <div className="mb-2">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#add_taxs"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Tax
                  </Link>
                </div>
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            <div className="row">
              {/* Total Plans */}
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center overflow-hidden">
                      <div>
                        <p className="fs-12 fw-medium mb-1 text-truncate">
                          Total Plans
                        </p>
                        <h4>
                          {data.length < 10
                            ? "0" + data.length
                            : data.length.toString()}
                        </h4>
                      </div>
                    </div>
                    <div>
                      <span className="avatar avatar-lg bg-primary flex-shrink-0">
                        <i className="ti ti-box fs-16" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Total Plans */}
              {/* Total Plans */}
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center overflow-hidden">
                      <div>
                        <p className="fs-12 fw-medium mb-1 text-truncate">
                          Active Plans
                        </p>
                        <h4>
                          {data.filter((item) => item.Status === "Active")
                            .length < 10
                            ? "0" +
                              data.filter((item) => item.Status === "Active")
                                .length
                            : data
                                .filter((item) => item.Status === "Active")
                                .length.toString()}
                        </h4>
                      </div>
                    </div>
                    <div>
                      <span className="avatar avatar-lg bg-success flex-shrink-0">
                        <i className="ti ti-activity-heartbeat fs-16" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Total Plans */}
              {/* Inactive Plans */}
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center overflow-hidden">
                      <div>
                        <p className="fs-12 fw-medium mb-1 text-truncate">
                          Inactive Plans
                        </p>
                        <h4>
                          {
                            data.filter((item) => item.Status == "Inactive")
                              .length
                          }
                        </h4>
                      </div>
                    </div>
                    <div>
                      <span className="avatar avatar-lg bg-danger flex-shrink-0">
                        <i className="ti ti-player-pause fs-16" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Inactive Companies */}
              {/* No of Plans  */}
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center overflow-hidden">
                      <div>
                        <p className="fs-12 fw-medium mb-1 text-truncate">
                          No of Plan Types
                        </p>
                        <h4>
                          {new Set(data.map((item) => item.Plan_Type)).size}
                        </h4>
                      </div>
                    </div>
                    <div>
                      <span className="avatar avatar-lg bg-skyblue flex-shrink-0">
                        <i className="ti ti-mask fs-16" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* /No of Plans */}
            </div>
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Plan List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-3">
                    <div className="input-icon-end position-relative">
                      <PredefinedDateRanges onDateChange={handleDateChange} />
                      <span className="input-icon-addon">
                        <i className="ti ti-chevron-down" />
                      </span>
                    </div>
                  </div>
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Select Plan
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setPlanFilter("Monthly")}
                        >
                          Monthly
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setPlanFilter("Yearly")}
                        >
                          Yearly
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Status {statusFilter}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setStatusFilter("Active")}
                        >
                          Active
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setStatusFilter("Inactive")}
                        >
                          Inactive
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By: {sortBy}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Recently Added")}
                        >
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Ascending")}
                        >
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Descending")}
                        >
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Last Month")}
                        >
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Last 7 Days")}
                        >
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <Table
                  key={JSON.stringify(filteredData)}
                  dataSource={filteredData}
                  columns={columns}
                  Selection={false}
                />
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © {company_short_name}</p>
            <p>
              Designed & Developed By{" "}
              <Link to="#" className="text-primary">
                {company_short_name}
              </Link>
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* Add Plan */}
        <div className="modal fade" id="add_plans">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Plan</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    {/* Add your form fields here */}
                    {/* Example for Plan Name */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Package Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="planName"
                          value={formData.planName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Plan Type <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="planType"
                          value={formData.planType}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {planType.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Price <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="price"
                          value={formData.price}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Tax <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="tax"
                          value={formData.tax}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {dataTax.map((data) => (
                            <option key={data.id} value={data.tax_rate}>
                              {data.tax_type} - {data.tax_rate}%
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Currency <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="currency"
                          value={formData.currency}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {dataCurrency.map((data, index) => (
                            <option
                              key={data.currency + index}
                              value={data.currency}
                            >
                              {data.currency} - {data.currency_symbol}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Discount <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="discountType"
                          value={formData.discountType}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {discountType.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Discount Value <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="discount"
                          value={formData.discount}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Status <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="status"
                          value={formData.status}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {status.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Plan Modules Section */}
                    <div className="col-md-12">
                      <h4>Permissions</h4>
                      <div>
                        {menuSubMenu.map((menu) => (
                          <div key={menu.key}>
                            <input
                              type="checkbox"
                              id={`menu-${menu.key}`}
                              onChange={() => handleMenuCheckbox(menu)}
                            />
                            <label htmlFor={`menu-${menu.key}`}>
                              {menu.title}
                            </label>

                            {/* Sub-menus */}
                            {selectedData.some(
                              (item: any) => item.menu === menu.title
                            ) && (
                              <div style={{ marginLeft: "20px" }}>
                                {menu.sub_menu.map(
                                  (subMenu: any, index: any) => (
                                    <div key={index}>
                                      <input
                                        type="checkbox"
                                        id={`submenu-${menu.key}-${index}`}
                                        onChange={() =>
                                          handleSubMenuCheckbox(menu, subMenu)
                                        }
                                        checked={selectedData
                                          .find(
                                            (item: any) =>
                                              item.menu === menu.title
                                          )
                                          ?.sub_menus.includes(subMenu)}
                                      />
                                      <label
                                        htmlFor={`submenu-${menu.key}-${index}`}
                                      >
                                        {subMenu}
                                      </label>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Description <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="description"
                          value={formData.description}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                  >
                    Add Package
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Plan */}

        {/* Add Tax */}
        <div className="modal fade" id="add_taxs">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Tax</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    {/* Add your form fields here */}
                    {/* Example for Plan Name */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Tax Type <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="taxType"
                          value={formDataTax.taxType}
                          onChange={handleInputChangeTax}
                        >
                          <option value="">Select</option>
                          {taxType.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Tax Rate <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="taxRate"
                          value={formDataTax.taxRate}
                          onChange={handleInputChangeTax}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Status <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="status"
                          value={formDataTax.status}
                          onChange={handleInputChangeTax}
                        >
                          <option value="">Select</option>
                          {status.map((data) => (
                            <option key={data.value} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmitTax}
                  >
                    Add Tax
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Tax */}

        {/* Edit Plan */}
        <div className="modal fade" id="edit_plans">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Plan</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-30.jpg"
                            alt="img"
                            className="rounded-circle"
                          />
                        </div>
                        <div className="profile-upload">
                          <div className="mb-2">
                            <h6 className="mb-1">Upload Profile Image</h6>
                            <p className="fs-12">Image should be below 4 mb</p>
                          </div>
                          <div className="profile-uploader d-flex align-items-center">
                            <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                              Upload
                              <input
                                type="file"
                                className="form-control image-sign"
                                multiple
                              />
                            </div>
                            <Link to="#" className="btn btn-light btn-sm">
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Plan Name<span className="text-danger"> *</span>
                        </label>
                        <CommonSelect
                          className="select"
                          options={planName}
                          defaultValue={planName[1]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Plan Type<span className="text-danger"> *</span>
                        </label>
                        <CommonSelect
                          className="select"
                          options={planType}
                          defaultValue={planType[1]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Plan Position<span className="text-danger"> *</span>
                        </label>
                        <CommonSelect
                          className="select"
                          options={planPosition}
                          defaultValue={planPosition[1]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Plan Currency<span className="text-danger"> *</span>
                        </label>
                        <CommonSelect
                          className="select"
                          options={currency}
                          defaultValue={currency[1]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <label className="form-label">
                            Plan Currency<span className="text-danger"> *</span>
                          </label>
                          <span className="text-primary">
                            <i className="fa-solid fa-circle-exclamation me-2" />
                            Set 0 for free
                          </span>
                        </div>
                        <CommonSelect
                          className="select"
                          options={plancurrency}
                          defaultValue={plancurrency[1]}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Discount Type<span className="text-danger"> *</span>
                        </label>
                        <div className="pass-group">
                          <CommonSelect
                            className="select"
                            options={discountType}
                            defaultValue={discountType[1]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Discount<span className="text-danger"> *</span>
                        </label>
                        <div className="pass-group">
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Limitations Invoices
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">Max Customers</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">Product</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">Supplier</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6>Plan Modules</h6>
                        <div className="form-check d-flex align-items-center">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Select All
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Employees
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Invoices
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Reports
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Contacts
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Clients
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Estimates
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Goals
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Deals
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Projects
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Payments
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Assets
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Leads
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Tickets
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Taxes
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Activities
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6">
                        <div className="form-check d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 text-dark fw-medium">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Pipelines
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                          <label className="form-check-label mt-0 me-2 text-dark fw-medium">
                            Access Trial
                          </label>
                          <div className="form-check form-switch me-2">
                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              role="switch"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-center gx-3">
                      <div className="col-md-4">
                        <div className="d-flex align-items-center mb-3">
                          <div className="flex-fill">
                            <label className="form-label">Trial Days</label>
                            <input type="text" className="form-control" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="d-block align-items-center ms-3">
                          <label className="form-check-label mt-0 me-2  text-dark">
                            Is Recommended
                          </label>
                          <div className="form-check form-switch me-2">
                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              role="switch"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Status<span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={status}
                            defaultValue={status[1]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Description</label>
                        <textarea className="form-control" defaultValue={""} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Plan */}
      </>
    );
  }
};

export default Packages;
